const request = (path, options = {}) =>
  fetch(process.env.REACT_APP_API_HOST + path, {
    credentials: 'include',
    ...options
  }).then(async response => {
    if (response.status === 204) {
      return ''
    } else if (!response.ok) {
      return Promise.reject(await response.json())
    }

    return response.json()
  })

export const post = (path, options = {}) =>
  request(path, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: options.payload ? JSON.stringify(options.payload) : undefined,
    ...options
  })



// WEBPACK FOOTER //
// ./src/utils/api.js